import React from "react";
import { Typography } from "@mui/material";

function PageTitles({ title }) {
  return (
    <>
      <Typography
        sx={{
          color: "#ca63f2",
          fontWeight: "bold",
          fontSize: "2rem",
          textAlign: "center",
          mb: 2,
        }}
      >
        {title}
      </Typography>
    </>
  );
}

export default PageTitles;
